// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/ScreenResolutionSelectWidget/styles.scss
// module id = 1000
// module chunks = 0